import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { authActions, alertActions } from '../../../store/actions'
import { valid } from "../../../hook/valid";
import Alert from "../../../module/alert/Alert";

const FindIdByEmail  = props => {

  //let gbn = new URL(window.location.href).searchParams.get("gbn");

  const [ state, setState ] = useState({
    name: '',
    email: '',
    submitted: false,
    gbn : ''
  })

  useEffect(() => {
    let gbn = new URL(window.location.href).searchParams.get("gbn");
    setState({
      ...state,
      gbn : gbn
    });
  }, []);


  useEffect(() => {
    let userId = "";

    if (props.data?.length > 0) {
      props.success({
        title:'아이디찾기',
        message: '가입시 등록한 이메일로 아이디가 발송되었습니다.',
        params: {
          type: 'success',
          action: 'authActions',
          method: 'resetFindInfo',
          params: null
        }
      })

    }
  }, [props.data]);


  const handleChange = (e) => {
    const { name, value } = e.target
    setState({
      ...state,
      [name]: value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    setState({
      ...state,
      submitted: true
    });

    const { name, email} = state

    if (props.checkFindInput(state)) {
      props.getFindUserId('email' ,{ name, email }, state.gbn );
    }
  }

  return(
      <React.Fragment>
        
            <div className="idpw-cont">
                <div className="login-input">
                <form name="form" onSubmit={handleSubmit} >
                  <fieldset>
                    <input type="text"
                        placeholder="이름 입력"
                        autoComplete="off"
                        title={"이름 입력"}
                        id="name" name="name"
                        value ={state.name}
                        onChange={handleChange}
                        />
                    <input type="text"
                        placeholder="이메일 주소 입력"
                        title={"이메일 주소 입력"}
                        autoComplete="off"
                        id="email" name="email"
                        value ={state.email}
                        onChange={handleChange} />
                  </fieldset>
                    <button className="btn-confirm">
                    확인
                    </button>
                    {/* <button className="login-btn btn">확인</button> */}
                </form>
                  <div className="idpw_list">
                  {
                    state.gbn === "1" && (
                    <a href="/login">로그인하기</a>
                    )
                  }
                  {
                    state.gbn === "2" && (
                    <a href="/loginCorp">로그인하기</a>
                    )
                  }
                  <a href={'/find/pass?gbn=' + state.gbn}>비밀번호 찾기</a>
                  </div>
                </div>
            </div>
            <div className="guide-box gray">
                <dl className="dlist1">
                  <dt>이용안내</dt>
                  <dd>가입시 등록된 휴대폰번호를 입력하셔야 확인 가능합니다.</dd>
                  <dd>자세한 문의는 고객센터로 문의해주세요.</dd>
                  <dd>가입 아이디가 많은 경우 이메일 확인을 추천드립니다.</dd>
                </dl>
            </div>
            
      </React.Fragment>
    )

}

const mapStateToProps = state => {
  return {
    data : state.auth.data,
  }
}

const actionCreators = {
  getFindUserId: authActions.getFindUserId,
  resetFindInfo: authActions.resetFindInfo,
  checkFindInput: valid.checkFindInput,
  success: alertActions.success,
}

export default connect(
  mapStateToProps,
  actionCreators
)(FindIdByEmail)
